<template>
    <c-contract-editor
        :title     = "$t('contract.dls.fulltitle')"
        :unit-data = "unitData"
        :terminate = "true"
        @store     = "onStore"
        @edit      = "onEdit"
        @start     = "onStart"
        @end       = "onEnde"
    >
        <template v-slot:additional>
            <v-row class="no-frame">
                <v-col class="no-frame pr-2 col-6">
                    <f-currency-field-rw
                        class         = "money"
                        :label        = "$t('contract.dls.netamount')"
                        :readonly     = "readonly"
                        v-model       = "unitData.netamount"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-2 col-6">
                    <f-currency-field-rw
                        class         = "money"
                        :label        = "$t('contract.dls.grossamount')"
                        :readonly     = "readonly"
                        v-model       = "unitData.grossamount"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>
        </template>
    </c-contract-editor>
</template>

<script>

import CContractEditor  from "@/modules/msd/company/contract/components/controls/CContractEditor.vue";
import FCurrencyFieldRw from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import Contract from "@/modules/msd/company/contract/service/Contract";
import Core from "@/modules/core/service/Core";

export default {
    name: "CContractDlsEditor",

    components: {
        FCurrencyFieldRw,
        CContractEditor,
    },

    props: {
        unit: {
            default: function () {
                return {
                    contractLimStart: null,
                    limGrossamount  : null,
                    limNetamount    : null
                }
            }
        }
    },

    data: () => ({
        readonly: true,
        unitData: {
            start      : null,
            netamount  : null,
            grossamount: null
        }
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unit () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveDls(this.unit.id, this.unit.contractLimId, this.unitData).then(() => {
                this.unit.contractLimStart = this.unitData.start;
                this.unit.contractLimExpiration = this.unitData.end;
                this.unit.limGrossamount   = this.unitData.grossamount;
                this.unit.limNetamount     = this.unitData.netamount;
                Core.message.hint(this, this.$t('contract.edit.stored'));
            });
        },

        onEdit (readonly) {
            this.readonly = readonly;
        },

        onStart (value) {
            this.unitData.start = value;
        },

        onEnde (value) {
            this.unitData.end = value;
        },

        setData () {
            this.unitData.start       = this.unit.contractLimStart;
            this.unitData.end         = this.unit.contractLimExpiration;
            this.unitData.grossamount = this.unit.limGrossamount;
            this.unitData.netamount   = this.unit.limNetamount;
        },
    }
}
</script>

<style scoped>

</style>